import { useCallback, useEffect, useMemo, useState } from 'react';
import { DEFAULT_MODEL, getModelConfig } from '../../../constants/models';

/**
 * Manages model selection and derived capabilities.
 */
export function useModelState({ activeMessages }) {
    const [selectedModel, setSelectedModel] = useState(() =>
        localStorage.getItem('selectedModel') || DEFAULT_MODEL
    );

    const isImageUploadEnabled = useMemo(() => {
        const modelConfig = getModelConfig(selectedModel);
        return modelConfig?.isImageSupported || false;
    }, [selectedModel]);

    const isReasoningModel = useMemo(() => {
        const modelConfig = getModelConfig(selectedModel);
        return modelConfig?.isReasoning || false;
    }, [selectedModel]);

    const handleModelChange = useCallback(modelId => {
        setSelectedModel(modelId);
        localStorage.setItem('selectedModel', modelId);
    }, []);

    useEffect(() => {
        if (activeMessages?.length > 0) {
            const lastAssistantMessage = [...activeMessages]
                .reverse()
                .find(msg => msg.sender === 'assistant' && msg.metadata?.model);

            if (lastAssistantMessage?.metadata?.model) {
                const modelConfig = getModelConfig(lastAssistantMessage.metadata.model);
                setSelectedModel(modelConfig?.id || DEFAULT_MODEL);
            } else {
                setSelectedModel(localStorage.getItem('selectedModel') || DEFAULT_MODEL);
            }
        } else {
            setSelectedModel(localStorage.getItem('selectedModel') || DEFAULT_MODEL);
        }
    }, [activeMessages]);

    return {
        selectedModel,
        handleModelChange,
        isImageUploadEnabled,
        isReasoningModel,
    };
}
